import { useEffect, useState } from "react";

import { Application } from "@core/Application";
import { Organization } from "@models/Organization";
import { CommunicationChannel, CommunicationChannelService } from "@services/CommunicationChannelService";
import { deriveQRMode, QRMode } from "@screens/QontactPoints/QontactPointDetailModalViewModel";

/**
 * Which check-in QR the qontact point shows, from the organization's channel
 * configuration: WhatsApp -> WhatsApp QR, app (WEBAPP) -> app QR. Any other
 * channel, or while it loads / if it fails, falls back to the feature flag rule.
 */
export const qrModeForChannel = (channel: CommunicationChannel | undefined, fallback: QRMode): QRMode => {
    if (channel === "WHATSAPP") return "whatsapp";
    if (channel === "WEBAPP") return "app";
    return fallback;
};

export const useQRMode = (org: Organization): QRMode => {
    const fallback = deriveQRMode(org.newFlags);
    const [channel, setChannel] = useState<CommunicationChannel | undefined>(undefined);

    useEffect(() => {
        let isCancelled = false;
        setChannel(undefined);
        new CommunicationChannelService(Application.shared().coreDependencies.httpClient)
            .getChannel(org.id)
            .then((value) => {
                if (!isCancelled) setChannel(value);
            })
            .catch((error) => console.error(error));
        return () => {
            isCancelled = true;
        };
    }, [org.id]);

    return qrModeForChannel(channel, fallback);
};

export default useQRMode;
